import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

type LoyaltyTitleProps = {
  title: string;
  className?: string;
  upperCase?: boolean;
};

export const LoyaltyTitle = ({
  title,
  className,
  upperCase,
}: LoyaltyTitleProps) => {
  const t = useTranslate();
  return (
    <h3
      className={classNames(
        "LoyaltyTitle",
        upperCase && "LoyaltyTitle_uppercase",
        className,
      )}
    >
      {t(title)}
    </h3>
  );
};
